export default {
  namespaced: true,

  state: {
    invoiceModalVisible: false,
  },

  getters: {
    isInvoiceModalVisible: (state) => state.invoiceModalVisible,
  },

  mutations: {
    SET_INVOICE_MODAL_VISIBLE(state, visible) {
      state.invoiceModalVisible = visible;
    },
  },

  actions: {
    openInvoiceModal({ commit }) {
      commit('SET_INVOICE_MODAL_VISIBLE', true);
    },

    closeInvoiceModal({ commit }) {
      commit('SET_INVOICE_MODAL_VISIBLE', false);
    },
  },
};
